import { isEqual } from 'lodash';
import { createSelector } from 'reselect';
import { Tier } from 'features/premium/entities';
import { isBefore } from 'date-fns';
import { selectFamilyPlanPrices } from 'features/premium/selectors/stripe';
import { selectShouldShowStripe } from 'features/premium/selectors';
/** Available to use/buy. Does not consider tier. */
export const selectIsExtraMembersFeatureAvailable = createSelector([selectShouldShowStripe, selectFamilyPlanPrices], (shouldShowStripe, familyPlanPrices) => shouldShowStripe && !!familyPlanPrices);
export const selectHasLoadedExtraMembersInfo = (state) => state.sharedPlans.extraMembersInfo !== null;
export const selectHasExtraMembersInfo = (state) => !!state.sharedPlans.extraMembersInfo;
export const selectExtraMembersInfo = createSelector([(state) => state.sharedPlans.extraMembersInfo], (info) => {
    if (info) {
        return {
            ...info,
            canAddSlot: info.totalSeats < 4,
            slotsLeft: info.totalSeats < 4 ? 4 - info.totalSeats : 0,
        };
    }
    return undefined;
}, {
    memoizeOptions: {
        resultEqualityCheck: (a, b) => isEqual(a, b),
    },
});
export const selectIsExtraMembersRenewing = createSelector([
    (state) => state.sharedPlans.extraMembersInfo,
    (state) => state.user.user.emmaProStatus,
], (extraMembersInfo, emmaProStatus) => {
    if (emmaProStatus.tier === Tier.ultimate) {
        if (emmaProStatus.autoRenewing &&
            emmaProStatus.autoRenewTier === Tier.ultimate) {
            return true;
        }
        if (extraMembersInfo && emmaProStatus.expiresOn) {
            return isBefore(extraMembersInfo.expiresOn, emmaProStatus.expiresOn);
        }
    }
    return false;
});
export const getUserHandle = (seat) => {
    if ('member' in seat) {
        return seat.member?.handle;
    }
    if ('invite' in seat) {
        return seat.invite?.handle;
    }
    return undefined;
};
export const selectExtraMembersUserHandleMap = createSelector([(state) => state.sharedPlans.extraMembersInfo], (extraMembersInfo) => {
    const seats = extraMembersInfo?.seats;
    if (seats) {
        const result = {};
        seats.forEach((seat) => {
            const handle = getUserHandle(seat);
            if (handle) {
                result[handle] = true;
            }
        });
        return result;
    }
    return {};
}, {
    memoizeOptions: {
        resultEqualityCheck: (a, b) => isEqual(a, b),
    },
});
